/* eslint no-console:0 */ // This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
// Setup dayjs plugins globally
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import utc from 'dayjs/plugin/utc';
import ReactRailsUJS from 'react_ujs';
dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(utc); // Keep an ajax counter (useful for knowing when the page
// has loaded in tests. Set it to 0 if no ajax is performed.
window.ajaxCount = -1;
window.loaded = false;
window.addEventListener('load', function () { window.loaded = true; if (window.ajaxCount === -1) {
    window.ajaxCount = 0;
} });
window.addEventListener('unload', function () { window.loaded = false; }); // Support component names relative to this directory:
const myCustomContext = require.context('components', true);
ReactRailsUJS.useContext(myCustomContext);
